import React, {Component} from 'react';
import {HashRouter as Router, Route, NavLink, Switch, Redirect} from "react-router-dom";
import {Provider} from 'react-redux'
import {TransitionGroup, CSSTransition} from "react-transition-group";
import store from './redux'
import PageOne from './pages/PageOne'
import PageTwo from './pages/PageTwo'
import PageThree from './pages/PageThree'

class App extends Component {
    menuList = [
        {
            icon: '',
            name: '一',
            path: '/one',
            component: PageOne
        }, {
            icon: '',
            name: '二',
            path: '/two',
            component: PageTwo
        }, {
            icon: '',
            name: '三',
            path: '/three',
            component: PageThree
        }
    ]
    render() {
        // let location = '/one'
        return (
            <Provider store={store}>
                <Router>
                    <Route
                        render={({location}) => {
                        return <div id="app">
                            <Route exact path="/" render={() => <Redirect to="/one/child/33/150/243"/>}/>
                            <div id="header">
                                {this
                                    .menuList
                                    .map((v, i) => {
                                        return <NavLink
                                            activeClassName="menu-item-active"
                                            className="menu-item"
                                            to={v.path}
                                            key={i}>
                                            <span>{v.name}</span>
                                        </NavLink>
                                    })}
                            </div>
                            <TransitionGroup className="content-main">
                                <CSSTransition key={location.key} classNames="fade" timeout={500}>
                                    <Switch location={location}>
                                        {this
                                            .menuList
                                            .map((v, i) => {
                                                return <Route key={i} path={v.path} component={v.component}/>
                                            })}
                                    </Switch>
                                </CSSTransition>
                            </TransitionGroup>
                        </div>
                    }}/>
                </Router>
            </Provider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js